(function () {
  function initSection(section) {
    var tabs = section.querySelectorAll('.oddit-section-collection-tab-grid__tab');
    var panels = section.querySelectorAll('.oddit-section-collection-tab-grid__products');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab-index');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('oddit-section-collection-tab-grid__tab--active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-tab-panel-index') === idx) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.oddit-section-collection-tab-grid')
      .forEach(initSection);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
